import { useState } from "react";
import { css } from "@emotion/react";

import { LoadingModal } from "../molecules";

const Top = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <>
      <div css={mainStyle} id="top">
        <LoadingModal isLoading={!isLoaded} />
        <img
          css={mainBGWrapperStyle(true)}
          src={process.env.REACT_APP_BASE_PATH + "/img/bg-top.jpg"}
          onLoad={() => setIsLoaded(true)}
        />
        {/*
        <img
          css={mainBGWrapperStyle}
          src={process.env.REACT_APP_BASE_PATH + "/img/_bg-min.jpg"}
        />
        <div css={actorWrapperStyle}>
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/top-actor-creator.png"}
            css={actorImgStyle}
          />
        </div>
        <img
          src={process.env.REACT_APP_BASE_PATH + "/img/top-trust-me.png"}
          css={trustMeImgStyle}
        />
        */}
      </div>
    </>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  color: #fff;
  display: flex;
`;

const mainBGWrapperStyle = (isLoaded: boolean) => css`
  z-index: -1;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  // load後opacityを0->1にアニメーションで表示
  // transition: opacity 1s;
  // opacity: ${isLoaded ? 1 : 0};

  @media (max-width: ${spSize}px) {
  }
`;

const actorWrapperStyle = css`
  position: absolute;
  top: 2%;
  left: 50%;
  height: auto;
  display: flex;
  flex-direction: column;
  transform: translateX(-50%);

  @media (max-width: ${spSize}px) {
    top: 22%;
  }
`;

const actorImgStyle = css`
  width: 22vw;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 26vw;
  }
`;

const trustMeImgStyle = css`
  position: absolute;
  top: 15%;
  left: 29%;
  width: 1.775vw;
  height: auto;

  @media (max-width: ${spSize}px) {
    top: 32%;
    left: 28%;
    width: 1.6vw;
  }
`;

export default Top;
